import React, { useEffect, useState } from "react";
import Canvas from "./Canvas";
import { ToastContainer } from "react-toastify";
import getUserData from "./utils/getSSO";
import { useMutateData } from "./services/api";
import UnauthorizedPage from "./components/403Forbiden";
import CircularProgress from "@mui/material/CircularProgress"; // Import CircularProgress
import store from "store2";
const App = () => {
	const [isVerified, setIsVerified] = useState(false);
	const { mutate, isLoading, isSuccess, isError } = useMutateData({
		onSuccess: (data) => {
			setIsVerified(data.status);
		},
		onError: (error) => {
			console.log("running from here");
		},
	});

	useEffect(() => {
		const getSSOKey = async () => {
			var ssoKey = "";
			window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
			window.addEventListener("message", ({ data }) => {
				if (data.message === "REQUEST_USER_DATA_RESPONSE") {
					ssoKey = data.payload;
					if (ssoKey) {
						const payload = {
							ssoToken: ssoKey,
						};

						store.session("_sso_session", ssoKey);
						mutate({ endPoint: "/sso-token-verify", data: payload });
					}
				}
				if (data.message === "LOCATION_CHANGED") {
					window.location.reload();
				}
			});
		};
		getSSOKey();

		return () => {
			window.removeEventListener("message", ({ data }) => {});
		};
	}, []);

	return (
		<>
			{isLoading ? ( // Show spinner if loading
				<CircularProgress
					style={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
					}}
				/>
			) : isVerified ? (
				<Canvas />
			) : (
				<UnauthorizedPage />
			)}

			<ToastContainer
				position="bottom-right"
				autoClose={2000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
			/>
		</>
	);
};

export default App;
